import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { UserDTO } from '../models/UserDTO.model';
import { PlanDTO } from '../models/PlanDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { SimpleRequestString } from '../shared/models/SimpleRequestString';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { CarrierDTO } from '../models/CarrierDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { PlanTypeDTO } from '../models/Plans/PlanTypeDTO';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
 

  constructor(private httpService: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
      })
    );
  }

  createPlan(plan: PlanDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.CreatePlan, plan).pipe(
      tap((data) => {
      })
    );
  }

  getAllPlans() {
    return this.httpService.get<PlanDTO[]>(ApiRoutesEnum.GetAllPlans).pipe(
      tap((data) => {
      })
    );
  }

  updatePlan(plan: PlanDTO) {
    return this.httpService.put<ResponseBase>(ApiRoutesEnum.UpdatePlan, plan).pipe(
      tap((data) => {
      })
    );
  }

  getPlanById(idPlan: number) {
    return this.httpService.get<PlanDTO>(ApiRoutesEnum.getPlanById + idPlan).pipe(
      tap((data) => {
      })
    );
  }

  getAllPlansAssignPlan() {
    return this.httpService.getAllPlansAssignPlan().pipe(
      tap((data) => {
      })
    );
  }

  getAllPlansTypePlan(data: SimpleRequestString) {
    return this.httpService.getAllPlansTypePlan(data).pipe(
      tap((data) => {
      })
    );
  }

  exportPlansListToExcel(){
    return this.httpService.exportPlansListToExcel().pipe(
      tap((data) => {
      })
    );
  }

   GetCarriers(){
    return this.httpService.post<CarrierDTO[]>(ApiRoutesEnum.GET_CARRIERS, {}).pipe(
      tap((data) => {
      })
    );
  }

   GetPlanTypeById(planTypeId: number){
    return this.httpService.get<PlanTypeDTO>(ApiRoutesEnum.GetPlanTypeById + planTypeId, {}).pipe(
      tap((data) => {
      })
    );
  }

  GetPlanTypes(){
    return this.httpService.get<PlanTypeDTO[]>(ApiRoutesEnum.GetPlanTypes, {}).pipe(
      tap((data) => {
      })
    );
  }

  GetPlanFrequencies(){
    return this.httpService.get<PlanTypeDTO[]>(ApiRoutesEnum.GetPlanFrequencies, {}).pipe(
      tap((data) => {
      })
    );
  }

   CreatePlanType(planType: PlanTypeDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.CreatePlanType, planType).pipe(
      tap((data) => {
      })
    );
  }

   UpdatePlanType(planType: PlanTypeDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.UpdatePlanType, planType).pipe(
      tap((data) => {
      })
    );
  }

}

